import API from '../../services/api-middleware';
import { forgotPasswordDetailProps } from '../pages/forgot-password/forgot-password.props';

const baseUrl = process.env.REACT_APP_USER_SERVER_URL;

export const forgotPassword = async (payload: forgotPasswordDetailProps) => {
  const data = {
    token: payload.token,
    email: payload.email,
  };
  try {
    const response = await API(baseUrl).post(`forgot-password`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const registerCompany = async (payload: Record<string, string>) => {
  try {
    const response = await API(baseUrl).post(`signup`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
